import React from "react";
import styled from "styled-components";
import Carousel from "./Carousel";

const ProjectSection = () => {
	return (
		<StyledSection
			data-aos="fade-up"
			data-aos-offset="200"
			data-aos-delay="10"
			data-aos-duration="1000"
			data-aos-easing="ease-in"
			data-aos-once="true"
		>
			<ProjectSectionHeader>
				<h3>Featured</h3>
				<div className="title-project">
					<h2>Projects</h2>
				</div>
				<span>
					Can’t display all the projects I have worked on due to{" "}
					<br />
					NDAs (Non Disclosure Agreements ).
				</span>
				<img src="./images/cone.png" alt="" className="cone" />
			</ProjectSectionHeader>

			<Carousel />
		</StyledSection>
	);
};

export default ProjectSection;

const StyledSection = styled.section`
	padding: 80px 16px;
`;
const ProjectSectionHeader = styled.div`
	position: relative;
	width: max-content;
	margin-left: 64px;
	@media (min-width: 750px) {
		max-width: 600px;
		margin: 0 auto;
	}

	@media (min-width: 1000px) {
		max-width: 800px;
	}
	.cone {
		width: 100px;
		position: absolute;
		top: 16px;
		left: -90px;

		@media (min-width: 1000px) {
			width: 180px;
			top: -25px;
			left: -155px;
		}
		@keyframes bounce {
			0% {
				transform: translateY(0);
			}

			100% {
				transform: translateY(-10px);
			}
		}
		& {
			animation: bounce 0.9s infinite alternate;
		}
	}

	h2 {
		margin: 0;

		@media (min-width: 1000px) {
			font-size: 8rem;
		}
	}
	h3 {
		line-height: 1;
		font-weight: 300;
		margin: 0;
	}

	span {
		display: inline-block;
		width: max-content;
		font-size: 0.7rem;
		color: rgba(220, 220, 220, 1);
	}
`;
